import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'

import Icon from '_components/icon'

import styles from './styles.css'

const ICONS = ['frown', 'meh', 'smile']

const ICON_BALLOONS = ['frown-balloon', 'meh-balloon', 'smile-balloon']

class RankSlider extends PureComponent {
  static propTypes = {
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
  }

  static defaultProps = {}

  render() {
    const { min, max, value, onChange, color } = this.props
    const marks = {}
    const marksStyle = {
      color: 'rgba(255,255,255,0.25)',
      marginTop: 8,
    }
    for (let i = min; i <= max; i++) {
      marks[i] = {
        style: marksStyle,
        label: i,
      }
    }

    const rankIconStep = (max - min) / 3
    const rankIconIndex = Math.min(Math.floor((value - min) / rankIconStep), 2)
    const iconLeft = (value - min) * (100 / (max - min))

    const percent = (100 * (value - min)) / (max - min)

    return (
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          margin: '0 7px 25px 0',
        }}
      >
        <div
          style={{
            position: 'relative',
            flex: 1,
            display: 'flex',
            margin: '0 0 10px',
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: `${iconLeft}%`,
              top: -8,
              transform: 'translateX(-50%)',
            }}
          >
            <Icon
              type={ICON_BALLOONS[rankIconIndex]}
              color="#F1E452"
              size={40}
              style={{ padding: 0 }}
              containerStyle={{ margin: 0 }}
            />
          </div>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              margin: '0 -18px',
            }}
          >
            {ICONS.map((i, index) => {
              const iconPercent = (100 * index) / (ICONS.length - 1)
              const percentMax = Math.max(percent, iconPercent)
              const percentMin = Math.min(percent, iconPercent)
              const diff = percentMax - percentMin

              return (
                <Icon
                  key={i}
                  type={i}
                  style={{ padding: 0 }}
                  color="rgba(255,255,255,0.4)"
                  size={25}
                  containerStyle={{ margin: 0, opacity: diff >= 100 / (max - min) ? 1 : 0 }}
                />
              )
            })}
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <Slider
            min={min}
            max={max}
            step={1}
            value={value}
            marks={marks}
            onChange={onChange}
            trackStyle={{ backgroundColor: color }}
            railStyle={{ backgroundColor: 'rgba(255,255,255,0.25)' }}
            handleStyle={{ border: 0, fontSize: 22 }}
            activeDotStyle={{ border: 0, backgroundColor: 'rgba(255,255,255,0.4)' }}
            dotStyle={{ border: 0, backgroundColor: 'rgba(255,255,255,0.4)' }}
          />
        </div>
      </div>
    )
  }
}

export default RankSlider



// WEBPACK FOOTER //
// ./src/components/slider/index.js